import { render, staticRenderFns } from "./XoaVaiTroModal.vue?vue&type=template&id=73452bb3&"
import script from "./XoaVaiTroModal.vue?vue&type=script&lang=js&"
export * from "./XoaVaiTroModal.vue?vue&type=script&lang=js&"
import style0 from "./XoaVaiTroModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports